import { CommonModule, Location, NgIf } from '@angular/common'
import { Component, OnInit } from '@angular/core'
import { ButtonComponent } from '@components/button/button.component'
import { TranslateModule, TranslateService } from '@ngx-translate/core'
import { ActivatedRoute, Router } from '@angular/router'
import { ApiService, UserInfo } from 'app/services/api.service'
import { PdfViewerModule } from 'ng2-pdf-viewer'
import { FormsModule } from '@angular/forms'
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser'
import { ContractType } from '../../interfaces/contract-type'
import { ConfirmModalComponent } from '@components/confirm-modal/confirm-modal.component'
import { CheckboxComponent } from '@components/checkbox/checkbox.component'
import { MenuItem } from '../../interfaces/api/MenuItem'
import { MenuService } from '../../services/menu.service'
import { LoadingService } from '../../services/loading.service'
import { MenuItemType } from '../../interfaces/api/MenuItemType'
import { AlertComponent } from '@components/alert/alert.component'


@Component({
    selector: 'app-sign-contract',
    templateUrl: './sign-contract.component.html',
    styleUrl: './sign-contract.component.scss',
    standalone: true,
    imports: [TranslateModule, NgIf, ButtonComponent, CommonModule, PdfViewerModule, FormsModule, ConfirmModalComponent, CheckboxComponent, AlertComponent]
})
export class SignContractComponent implements OnInit{
    public contractId: ContractType;
    public contractUrl: string = ''
    public acceptTerms: boolean = false
    showContactModal: boolean = false
    isSignable: boolean;
    redirectMenuItem: MenuItem

    userInfo: UserInfo
    documentLoaded: boolean = false
    contractInformationLoaded = false
    shouldLoadInIframe: boolean = false
    iframeUrl: SafeResourceUrl = ''

    constructor(
        private location: Location,
        private router: Router,
        private activatedRoute: ActivatedRoute,
        private api: ApiService,
        private menuService: MenuService,
        private loadingService: LoadingService,
        private translate: TranslateService,
        public sanitizer: DomSanitizer,
    ) {
        this.contractId = this.activatedRoute.snapshot.params['contractId']

        this.redirectMenuItem = this.router?.getCurrentNavigation()?.extras?.state?.['link']
        if(!this.redirectMenuItem){
            this.router.navigate(['home'])
            return;
        }
        this.loadingService.show()

        this.loadTranslations()
    }

    ngOnInit() {
        this.userInfo = this.api.userInfo.getValue()

        if(sessionStorage.getItem('is-' + this.contractId + '-signed')){
            this.redirect()
        }

        this.api.getContractInfo(this.contractId).subscribe({
            next: (contract) => {
                if(contract.isSigned) {
                    this.redirect()
                    sessionStorage.setItem('is-' + this.contractId + '-signed', 'true')
                    return;
                }

                this.loadingService.hide()
                this.contractInformationLoaded = true;
                this.isSignable = contract.canSign
                this.contractUrl = contract.contractUrl
                if(this.contractUrl && this.contractUrl.includes('forms.cosentino.com')){
                    this.documentLoaded = true;
                    this.shouldLoadInIframe = true;
                    this.iframeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.contractUrl) //NOSONAR
                }
            }, error: error => {
                this.loadingService.hide()
                if(error && error.status !== 403){
                    this.contractInformationLoaded = true;
                    console.error('Error loading contract', error);
                }
            }
        })
    }

    redirect(){
        if(this.redirectMenuItem.type !== MenuItemType.LINK){
            this.loadingService.hide()
        }
        this.menuService.goTo(this.redirectMenuItem, true)
    }

    goBack() {
        this.location.back()
    }
    
    goHome(){
        this.router.navigate(['home'], {onSameUrlNavigation: 'reload'})
    }

    signContract() {
        if (this.acceptTerms) {
            this.api.signContract(this.contractId).subscribe({
                next: (next: boolean) => {
                    if(next){
                        sessionStorage.setItem('is-' + this.contractId + '-signed', 'true')
                        this.menuService.goTo(this.redirectMenuItem, true)
                        return;
                    }
                    console.error('Error signing contract.')
                    //TODO Add actual user friendly error notifications
                    alert('Error signing contract.')
                }, error: (error) => {
                    console.error('Error signing contract.', error)
                    //TODO Add actual user friendly error notifications
                    alert('Error signing contract.')
                }
            })
        }
    }

    openContact() {
        this.showContactModal = true
    }

    getDescription(){
        const description: string = this.translate.instant('contract.descriptions.' + this.contractId)
        if(!description || description.includes('contract.descriptions.')){
            return this.translate.instant('contract.if_you_have_questions_please_ask_your_manager')
        } else {
            return description;
        }
    }

    private loadTranslations() {
        this.translate.get([
            'contract.descriptions.my-leads'
        ])
    }
}
